<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
          >
            Inventario Histórico Detallado
            <router-link
              :to="{
                name: 'InventarioHistorico',
                params: { almacen: almacen, fechas: fechas }
              }"
            >
              <CButton color="primary" class="mr-1 btn-header">
                <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody v-show="items.length > 0">
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
              <label style="width:76px;">Almacén: </label>
              <CCol md="6" lg="6">
                <template>
                  <CInput lg="6" :disabled="true" v-model="almacenNombre" />
                </template>
              </CCol>
            </div>
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
              <label style="width:76px;">Categoría: </label>
              <CCol md="6" lg="6">
                <template>
                  <CInput lg="6" :disabled="true" v-model="categoria" />
                </template>
              </CCol>
            </div>
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
              <label style="width:76px;">Producto: </label>
              <CCol md="6" lg="6">
                <template>
                  <CInput lg="6" :disabled="true" v-model="producto" />
                </template>
              </CCol>
            </div>
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
              <label style="width:76px;">Fecha Inicial: </label>
              <CCol md="6" lg="6">
                <template>
                  <CInput
                    lg="6"
                    type="date"
                    :disabled="true"
                    v-model="fecha_inicial"
                  />
                </template>
              </CCol>
            </div>
            <div class="d-flex align-items-center flex-wrap flex-sm-nowrap">
              <label style="width:76px;">Fecha Final: </label>
              <CCol md="6" lg="6">
                <template>
                  <CInput
                    lg="6"
                    type="date"
                    :disabled="true"
                    v-model="fecha_final"
                  />
                </template>
              </CCol>
            </div>
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="filteredItems"
              :fields="fields"
              :noItemsView="noItems"
            >
              <template #FECHA="{ item }">
                <td class="py-2">{{ item.fecha }}</td>
              </template>
              <template #TIPO="{ item }">
                <td class="py-2">{{ getTipo(item.tipo) }}</td>
              </template>
              <template #INVENTARIO_INICIAL="{ item }">
                <td class="py-2 text-right">
                  {{ $formatter(item.inventario_inicial) }}
                </td>
              </template>
              <template #ENTRADAS="{ item }">
                <td class="py-2ht text-right">
                  {{ $formatter(item.entradas) }}
                </td>
              </template>
              <template #SALIDAS="{ item }">
                <td class="py-2ht text-right">
                  {{ $formatter(item.salidas) }}
                </td>
              </template>
              <template #INVENTARIO_FINAL="{ item }">
                <td class="py-2 text-right">
                  {{ $formatter(item.inventario_final) }}
                </td>
              </template>
            </CDataTable>
          </CCardBody>
          <CCardBody v-show="items.length == 0 && isLoading == false">
            <CDataTable
              hover
              bordered
              small
              :noItemsView="noItemsInv"
            ></CDataTable>
          </CCardBody>
          <CCardBody v-show="isLoading == true">
            <CDataTable
              hover
              bordered
              small
              :loading="isLoading"
              :noItemsView="noItems"
            ></CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";

const fields = [
  { key: "FECHA", label: "Fecha", _style: "width:10%" },
  { key: "TIPO", label: "Tipo", _style: "width:10%" },
  {
    key: "INVENTARIO_INICIAL",
    label: "Inventario inicial",
    _style: "width:10%"
  },
  { key: "ENTRADAS", label: "Entradas", _style: "width:10%" },
  { key: "SALIDAS", label: "Salidas", _style: "width:10%" },
  { key: "INVENTARIO_FINAL", label: "Inventario final", _style: "width:10%" }
];

export default {
  name: "InvetarioHistoricoDetallado",

  components: {
    Multiselect
  },

  data() {
    return {
      producto: this.$route.params.producto,
      almacen: this.$route.params.almacen,
      almacenNombre: this.$route.params.almacenNombre,
      fechas: this.$route.params.fechas,
      categoria: "",
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      noItemsInv: {
        noResults: "Sin Resultados",
        noItems: "Sin entradas y salidas en esas fechas"
      },
      items: [],
      fields,
      filter: "",
      isLoading: false,
      fecha_inicial: "",
      fecha_final: "",
      cont: 0,
      invIn: null,
      invFin: 0,
      vacio: false
    };
  },

  created() {
    this.isLoading = true;
    let productos = {
      schema: "productos",
      filter: {
        where: [
          {
            field: "payload->nombre",
            operator: "=",
            value: this.producto
          }
        ]
      }
    };
    Promise.all([this.$store.dispatch("customHTTP", productos)])
      .then(([productos]) => {
        this.actualizarInfo(productos.data[0].id);
      })
      .catch(rej => console.log(rej.message))
      .finally(() => (this.isLoading = true));
  },

  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation
        ? this.$store.state.rootLocation.value
        : "";
    },
    filteredItems() {
      var tot = 0;
      var cont = 0;
      this.items.forEach(item => {
        if (item.inventario_inicial >= 0) {
          item.inventario_final =
            item.inventario_inicial +
            Number(item.entradas) -
            Number(item.salidas);
          tot =
            item.inventario_inicial +
            Number(item.entradas) -
            Number(item.salidas);
        } else {
          item.inventario_inicial = tot;
          item.inventario_final =
            item.inventario_inicial +
            Number(item.entradas) -
            Number(item.salidas);
          tot =
            item.inventario_inicial +
            Number(item.entradas) -
            Number(item.salidas);
        }
      });
      return this.items;
    }
  },

  methods: {
    getTipo(tipo) {
      if (tipo == "E") {
        return "Entrada";
      } else {
        return "Salida";
      }
    },
    actualizarInfo(producto_id) {
      this.isLoading = true;

      let template = {
        body: {
          reporte: "kardex_detallado",
          params: {
            fecha: [
              moment(this.fechas.start).format("YYYY-MM-DD"),
              moment(this.fechas.end).format("YYYY-MM-DD")
            ],
            almacen_id: this.almacen.value,
            producto_id: producto_id,
            ubicaciones: [this.ubicacionRaiz]
          }
        }
      };

      Promise.all([this.$store.dispatch("customIndicadoresHTTP", template)])
        .then(([saldos]) => {
          this.items = saldos.data;
          this.almacenNombre = saldos.data[0].almacen;
          this.categoria = saldos.data[0].categoria;
          this.producto = saldos.data[0].producto;
          this.fecha_final = saldos.data[0].fecha_final;
          this.fecha_inicial = saldos.data[0].fecha_inicial;
        })
        .catch(rej => console.log(rej.message))
        .finally(() => (this.isLoading = false));
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }
  .text-sm {
    font-size: 11px !important;
  }
  .margin-sm {
    margin: 5px;
  }
}
</style>
